import { ProductCompliance } from '~/Api/CzSuklCompliance';
import GeneralProduct from '~/Api/Product/Product';

import { ProductDataSource } from './ProductDataSource';
import { ReferencePrice } from './ReferencePrice';

export class Product {
	product: GeneralProduct;

	datasource: ProductDataSource;

	referencePrices: ReferencePrice[];

	packageSizeForCalculation: number | null;

	packageSizeForSingleUnit: number | null;

	singleUnitPackageSize: boolean;

	selected: boolean;

	productCompliance: ProductCompliance;

	constructor(
		product: GeneralProduct,
		datasource: ProductDataSource,
		referencePrices: ReferencePrice[],
		packageSizeForCalculation: number | null,
		packageSizeForSingleUnit: number | null,
		singleUnitPackageSize: boolean,
		selected: boolean,
		productCompliance: ProductCompliance
	) {
		this.product = product;
		this.datasource = datasource;
		this.referencePrices = referencePrices;
		this.packageSizeForCalculation = packageSizeForCalculation;
		this.packageSizeForSingleUnit = packageSizeForSingleUnit;
		this.singleUnitPackageSize = singleUnitPackageSize;
		this.selected = selected;
		this.productCompliance = productCompliance;
	}

	findSelectedReferencePrice(): ReferencePrice | null {
		return this.referencePrices.find((price) => price.calculatedPrice.selected) ?? null;
	}
}
